import { Box } from '@mui/joy'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/common/viewer'
import { logger } from '~/shared/lib/logger'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { ArrowCircleBrokenDownIcon } from '~/shared/ui/Icons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { Form, FormValues } from './Form'
import { setMainFx } from './model'

export function ChangeAggregatorDriverModal() {
  const { t } = useTranslation()

  const { canDriverSetMainAggregator } = usePermissions()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const { isModalShow, closeModal, openModal } = useModal()
  const queryClient = useQueryClient()

  const handleOnOk = useCallback(
    async (formValues: FormValues) => {
      try {
        setIsSubmitting(true)
        await setMainFx({ aggregatorDriverId: formValues.aggregatorDriver })
        await queryClient.invalidateQueries({
          queryKey: ['aggregators-driver'],
        })
        closeModal()
      } catch (e) {
        logger.error(e)
      } finally {
        setIsSubmitting(false)
      }
    },
    [closeModal, queryClient],
  )

  if (!canDriverSetMainAggregator) return null

  return (
    <>
      <Button
        variant='brand'
        onClick={openModal}
        startDecorator={<ArrowCircleBrokenDownIcon />}
      >
        {t('button.select primary account')}
      </Button>

      <Modal
        isShow={isModalShow}
        onCancel={closeModal}
        title={t('button.change primary account')}
        dialogProps={{
          sx: {
            minWidth: '600px',
            maxWidth: '600px',
          },
        }}
      >
        <Box sx={{ padding: '4px' }}>
          <Alert variant='warning'>
            {t(
              'alert.you are selecting the drivers primary account in the aggregator where all balance transactions will be credited',
            )}
          </Alert>
          <br />
          <Form
            onSuccess={handleOnOk}
            isSubmitting={isSubmitting}
            onCancel={closeModal}
          />
        </Box>
      </Modal>
    </>
  )
}
